import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";
import type { PanelModerationStatus } from "../types";

interface PanelStatusBadgeProps {
  status: PanelModerationStatus;
}

const statusClass: Record<PanelModerationStatus, string> = {
  pending: "bg-amber-500/20 text-amber-400 border-amber-500/30",
  approved: "bg-green-500/20 text-green-400 border-green-500/30",
  rejected: "bg-red-500/20 text-red-400 border-red-500/30",
};

const PanelStatusBadge = ({ status }: PanelStatusBadgeProps) => {
  const { t } = useTranslation("common");
  const labels: Record<PanelModerationStatus, string> = {
    pending: t("PANELS.statusPending", "Pending"),
    approved: t("PANELS.statusApproved", "Approved"),
    rejected: t("PANELS.statusRejected", "Rejected"),
  };
  return <Badge className={statusClass[status]}>{labels[status]}</Badge>;
};

export default PanelStatusBadge;
